<template>
    <div class="tl">
        <template>
            <el-tabs type="border-card" @tab-click="handleClick">
                <el-tab-pane label="收货">
                    <div v-if="tabIndex == 0">
                        <receiving-list ref="receivingList" :formvalue="formvalue"></receiving-list>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </template>

    </div>
</template>

<script>

    import ReceivingList from "./receive/ReceivingList";
    export default {
        name: "TabsList",
        components: {ReceivingList},
        props:{
            tabslist:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                formvalue:{},
                tabIndex:0,
                i_type:3,
            }
        },
        watch:{
            tabslist(){
                if (this.tabslist){
                    //this.i_type=this.tabslist.i_type;
                    this.formvalue=this.tabslist;
                    // console.log(this.formvalue,"this.formvalue");
                }
            },
            immediate:true,
            deep:true
        },
        mounted() {

        },
        methods: {
            handleClick(tab){
                this.tabIndex = tab.index;
                if (this.tabIndex==0){
                    // this.getEntrustCompanyHaveList();
                }
                // else if(this.tabIndex==1){
                //     this.$refs.forChildren.getPickingReqList() //父组件调子组件
                // }
            },
            proDetails(val){
                this.$emit('refreshTask',val);
                // console.log("proDetails")
            },
            /*entrustDetails(){
                console.log("entrustDetails")
            }*/
        },
    }
</script>

<style lang="scss" scoped>
    .el-tabs--border-card{
        height: calc(90vh - 100px);
    }
</style>